import axios from 'axios';
import TokenManagerService from '../../../services/TokenManagerService';

class etlService {
    constructor() {
        this.state = {
            apiUrl: process.env.REACT_APP_API_URL,
        };
    }

    /**
     * Returns a headers object with the current in-memory access token.
     */
    _authHeaders() {
        const token = TokenManagerService.getAccessToken();
        return {
            Authorization: token ? `Bearer ${token}` : undefined,
        };
    }

    PresignUploadUrls(data) {
        return axios
            .post(this.state.apiUrl + 'home/presignUploadUrl', data, { silent: true })
            .then((res) => {
                return res.data;
            })
            .catch((err) => {
                return err;
            });
    }

    getEtlJobList(data) {
        return axios
            .post(this.state.apiUrl + 'etl/jobList', data, { silent: true })
            .then((res) => {
                return res.data;
            })
            .catch((err) => {
                return err;
            });
    }

    getEtlJobErrorData(dataSourceId, perPage, page, customerId, mode) {
        const url =
            this.state.apiUrl +
            'etl/jobErrorData?dataSourceId=' +
            dataSourceId +
            '&perPage=' +
            perPage +
            '&page=' +
            page +
            '&customerId=' +
            customerId +
            '&mode=' +
            mode;
        if (
            url.includes(
                this.state.apiUrl +
                    'etl/jobErrorData?dataSourceId=' +
                    dataSourceId +
                    '&perPage=' +
                    perPage +
                    '&page=' +
                    page +
                    '&customerId=' +
                    customerId +
                    '&mode=' +
                    mode,
            )
        ) {
            return axios
                .get(url, { silent: true })
                .then((res) => {
                    return res.data;
                })
                .catch((err) => {
                    return err;
                });
        }
    }

    getEtlJobErrorDataFileDownloadUrl(dataSourceId, customerId, mode) {
        const url =
            this.state.apiUrl +
            'etl/downloadJobErrorDataFile/' +
            dataSourceId +
            '?customerId=' +
            customerId +
            '&mode=' +
            mode;
        if (
            url.includes(
                this.state.apiUrl +
                    'etl/downloadJobErrorDataFile/' +
                    dataSourceId +
                    '?customerId=' +
                    customerId +
                    '&mode=' +
                    mode,
            )
        ) {
            axios({
                url: url,
                method: 'GET',
                responseType: 'blob',
                silent: true,
            })
                .then((response) => {
                    this.downloadFile(response.data, `Error-TherigyVista-JobID-${dataSourceId}.xlsx`);
                })
                .catch((err) => {
                    return err;
                });
        }
    }

    getEtlAllTemplates(customerId) {
        const url = this.state.apiUrl + 'etl/listFileTemplates?customerId=' + customerId;
        if (url.includes(this.state.apiUrl + 'etl/listFileTemplates?customerId=' + customerId)) {
            return axios
                .get(url, { silent: true })
                .then((res) => {
                    return res.data;
                })
                .catch((err) => {
                    return err;
                });
        }
    }

    getEtlTemplateDownloadUrl(fileTemplateId, name, extesion) {
        const url = this.state.apiUrl + 'etl/downloadFileTemplate/' + fileTemplateId;
        if (url.includes(this.state.apiUrl + 'etl/downloadFileTemplate/' + fileTemplateId)) {
            axios({
                url: url,
                method: 'GET',
                responseType: 'blob',
                silent: true,
            })
                .then((response) => {
                    this.downloadFile(response.data, `${name}.${extesion}`);
                })
                .catch((err) => {
                    return err;
                });
        }
    }

    getEtlGeneratedTestDataDownloadUrl(fileTemplateId, sizeLabel) {
        return (
            this.state.apiUrl +
            'etl/generateAndDownloadFile/' +
            fileTemplateId +
            '?sizeLabel=' +
            sizeLabel +
            '&AUTH_TOKEN=' +
            this._authHeaders().Authorization
        );
    }

    generateEtlTestDataFileOnServer(fileTemplateId, sizeLabel) {
        const url = this.state.apiUrl + 'etl/generateFile/' + fileTemplateId + '?sizeLabel=' + sizeLabel;
        if (url.includes(this.state.apiUrl + 'etl/generateFile/' + fileTemplateId + '?sizeLabel=' + sizeLabel)) {
            return axios
                .get(url, { silent: true })
                .then((res) => {
                    return res.data;
                })
                .catch((err) => {
                    return err;
                });
        }
    }

    getEtlAddressesDownloadUrl(customerId) {
        return (
            this.state.apiUrl + 'etl/downloadAddreses/' + customerId + '?AUTH_TOKEN=' + this._authHeaders().Authorization
        );
    }

    downloadFile(data, filename) {
        // create file link in browser's memory
        const href = URL.createObjectURL(data);
        // create "a" HTML element with href to file & click
        const link = document.createElement('a');
        link.href = href;
        link.setAttribute('download', filename);
        link.id = 'someid';
        link.style.display = 'none';
        document.body.appendChild(link);
        link.click();
        // clean up "a" element & remove ObjectURL
        document.body.removeChild(link);
        URL.revokeObjectURL(href);
    }
}

export default etlService;
